import Cookies from 'js-cookie';
import authActions from './actions';
import { DataService } from '../../config/dataService/dataService';
import { ALLOWED_ROLES } from '../../components/utilities/auth-info/utils';
import { disconnectWebSocket } from '../socket/actions';

const { loginBegin, loginSuccess, loginErr, logoutBegin, logoutSuccess, logoutErr } = authActions;

const login = (values, callback) => {
  const { keepMeLoggedIn } = values
  return async (dispatch) => {
    dispatch(loginBegin());
    try {
      const response = await DataService.post('/auth/login', values);
      if (Boolean(response.data.status) !== true) {
        dispatch(loginErr(response.data.message));
      } else {
        const { data } = response.data;
        if (!ALLOWED_ROLES[data.api_url]) {
          dispatch(loginErr("User logged in but system is not ready for you yet, stay tuned !, contact administrator for further updates"));
          return
        }

        Cookies.set('access_token', data.access_token);
        Cookies.set('logedIn', true);
        Cookies.set('keepMeLoggedIn', keepMeLoggedIn);
        // if (keepMeLoggedIn) {
        // }
        dispatch(loginSuccess(true, data));
        if (callback) callback(data);
      }
    } catch (error) {
      dispatch(loginErr(error.message));
    }
  };
};

// const authOLogin = (values, callback) => {
//   return async (dispatch) => {
//     dispatch(loginBegin());
//     Cookies.set('access_token', values.accessToken);
//     Cookies.set('logedIn', true);
//     dispatch(loginSuccess(true));
//     callback();
//   };
// };

// const register = (values) => {
//   return async (dispatch) => {
//     dispatch(loginBegin());
//     try {
//       const response = await DataService.post('/register', values);
//       if (response.data.errors) {
//         dispatch(loginErr('Registration failed!'));
//       } else {
//         dispatch(loginSuccess(false));
//       }
//     } catch (err) {
//       dispatch(loginErr(err));
//     }
//   };
// };

const logOut = (callback) => {
  return async (dispatch) => {
    dispatch(logoutBegin());
    try {
      Cookies.remove('logedIn');
      Cookies.remove('access_token');
      dispatch(logoutSuccess(false));
      dispatch(disconnectWebSocket());
      
      callback();
    } catch (err) {
      dispatch(logoutErr(err));
    }
  };
};

export { login, logOut };
